// extracted by mini-css-extract-plugin
module.exports = {"bottomButton":"bottomButton_bottomButton__2Ec-3","mainBtn":"bottomButton_mainBtn__3RPYI","secondaryBtn":"bottomButton_secondaryBtn__1UVzm"};